import { Loader2, Save } from "lucide-react";

export const Txt = ({ value, onChange, className = "", testid, ...p }) => (
  <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className={`w-full rounded-md border border-brand-line bg-white px-2.5 py-1.5 text-sm outline-none focus:border-brand-accent ${className}`} {...p} />
);

export const Num = ({ value, onChange, className = "", testid, step = "any", ...p }) => (
  <input type="number" step={step} value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))} data-testid={testid}
    className={`w-full font-mono-num rounded-md border border-brand-line bg-white px-2.5 py-1.5 text-sm outline-none focus:border-brand-accent ${className}`} {...p} />
);

export const Sel = ({ value, onChange, options, testid }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className="w-full rounded-md border border-brand-line bg-white px-2 py-1.5 text-sm outline-none focus:border-brand-accent">
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);

export const Toggle = ({ on, onChange, label, testid }) => (
  <button type="button" onClick={() => onChange(!on)} data-testid={testid}
    className={`inline-flex items-center gap-2 text-xs rounded-full px-3 py-1 border transition-colors ${on ? "bg-brand-ink text-brand-cream border-brand-ink" : "border-brand-line text-brand-muted"}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${on ? "bg-brand-accent" : "bg-brand-line"}`} />{label || (on ? "Active" : "Hidden")}
  </button>
);

export const slug = (s) => s.toLowerCase().trim().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 40);

export const SaveBar = ({ dirty, saving, onSave, onReset, children }) => (
  <div className="sticky bottom-4 mt-8 rounded-2xl bg-brand-ink text-brand-cream px-5 py-3 flex items-center justify-between gap-4 shadow-2xl" data-testid="admin-save-bar">
    <p className="text-xs text-brand-muted-light">{dirty ? "Unsaved changes — prices go live on the next quotation once saved." : "All changes saved."}</p>
    <div className="flex items-center gap-3">
      {children}
      {onReset && <button onClick={onReset} className="text-xs text-brand-line hover:text-white" data-testid="admin-discard-btn">Discard</button>}
      <button onClick={onSave} disabled={!dirty || saving} data-testid="admin-save-btn"
        className="inline-flex items-center gap-2 rounded-full bg-brand-accent hover:bg-brand-accent-dark disabled:opacity-50 px-5 py-2 text-sm transition-colors">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save changes
      </button>
    </div>
  </div>
);

export const SectionHead = ({ title, sub, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div><h2 className="font-serif-display text-3xl text-brand-ink">{title}</h2>{sub && <p className="text-sm text-brand-muted mt-1">{sub}</p>}</div>
    {action}
  </div>
);
